import { useState } from 'react';
import Logo from '../components/Logo';
import { APP_NAME } from '../version';
import { useAuth } from '../context/AuthContext';

function SkyScene() {
  return (
    <div className="sky" aria-hidden="true">
      <div className="sky__cloud sky__cloud--1" />
      <div className="sky__cloud sky__cloud--2" />
      <div className="sky__cloud sky__cloud--3" />
      <svg className="sky__scene" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
        <g className="sky__rings" transform="translate(1000 660)" fill="none">
          <circle r="90" /><circle r="170" /><circle r="250" /><circle r="330" />
          <line x1="-330" y1="0" x2="330" y2="0" /><line x1="0" y1="-330" x2="0" y2="330" />
        </g>
        <path id="fd-flightpath" className="sky__path" d="M -60 730 C 300 660 470 320 1260 150" fill="none" />
        <g className="sky__plane">
          <path d="M22 0 L-20 -13 L-7 0 L-20 13 Z" />
          <animateMotion dur="16s" repeatCount="indefinite" rotate="auto">
            <mpath href="#fd-flightpath" xlinkHref="#fd-flightpath" />
          </animateMotion>
        </g>
      </svg>
    </div>
  );
}

export default function SignIn() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const msError = new URLSearchParams(window.location.search).get('auth_error');

  async function submit() {
    if (!email || !password) { setError('Enter your email and password.'); return; }
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(err?.detail || 'Sign-in failed.');
    } finally {
      setBusy(false);
    }
  }

  function onKey(e) {
    if (e.key === 'Enter') submit();
  }

  return (
    <div className="signin signin--sky">
      <SkyScene />
      <div className="signin__card">
        <div className="signin__brand">
          <Logo size={28} />
          <span className="signin__wordmark">{APP_NAME}</span>
        </div>
        <p className="signin__lede">Billing &amp; accounting for Inflight Technology.</p>

        {(error || msError) && <div className="form-error">{error || msError}</div>}

        <div className="field">
          <label>Email</label>
          <input type="email" value={email} autoFocus
            onChange={(e) => setEmail(e.target.value)} onKeyDown={onKey} />
        </div>
        <div className="field">
          <label>Password</label>
          <input type="password" value={password}
            onChange={(e) => setPassword(e.target.value)} onKeyDown={onKey} />
        </div>
        <button className="btn btn--primary btn--block" onClick={submit} disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <div className="signin__divider"><span>or</span></div>

        <a className="btn btn--block" href="/api/auth/microsoft">Sign in with Microsoft</a>

        <p className="signin__foot">Access is limited to authorized accounts.</p>
      </div>
    </div>
  );
}
